import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, roleHome } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AuthCallback() {
    const { googleSession } = useAuth();
    const navigate = useNavigate();
    const done = useRef(false);

    useEffect(() => {
        if (done.current) return;
        done.current = true;
        const hash = window.location.hash;
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            toast.error("Google sign-in failed. Please try again.");
            navigate("/login");
            return;
        }
        googleSession(match[1])
            .then((user) => {
                toast.success(`Welcome, ${user.name}!`);
                navigate(roleHome(user.role));
            })
            .catch((e) => {
                toast.error(formatApiError(e));
                navigate("/login");
            });
    }, [googleSession, navigate]);

    return (
        <div className="grid min-h-screen place-items-center bg-background" data-testid="auth-callback-page">
            <p className="text-sm text-muted-foreground">Signing you in with Google...</p>
        </div>
    );
}
